import { Loader2 } from 'lucide-react';

// Layout-preserving Suspense fallback for lazy route chunks.
export const RouteFallback = () => (
  <div className="flex min-h-[50vh] w-full flex-1 items-center justify-center bg-background">
    <Loader2
      className="h-6 w-6 animate-spin text-gray-dark motion-reduce:animate-none"
      aria-hidden
    />
    <span className="sr-only">Loading</span>
  </div>
);
